var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { applyLogoThumbnailSize, applyOpenGraphThumbnailSize, classNames, firstImageProperty } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { Image } from '../elements/image';
import { useLink } from '../hooks/use-link';
import { animated, useSpring } from '@react-spring/web';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
var cls = classNames('logo-card');
export var OrganisationLogoCardDefaultProps = {
  animate: true,
  index: 0,
  size: 100
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    display: flex;\n\n    ", "\n\n    padding: 16px;\n    font-family: ", ";\n    font-size: ", ";\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    img {\n      object-fit: contain !important;\n    }\n\n    a {\n      text-decoration: none;\n      display: flex;\n      flex-grow: 1;\n    }\n  "], ["\n    background: ", ";\n    display: flex;\n\n    ", "\n\n    padding: 16px;\n    font-family: ", ";\n    font-size: ", ";\n    flex-grow: 1;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    img {\n      object-fit: contain !important;\n    }\n\n    a {\n      text-decoration: none;\n      display: flex;\n      flex-grow: 1;\n    }\n  "])), theme.COLOR('bright'), function (_a) {
    var logoSize = _a.logoSize;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n      min-width: ", "px;\n    "], ["\n      height: ", "px;\n      min-width: ", "px;\n    "])), logoSize, logoSize);
  }, theme.FONT('sans'), theme.FONT_SIZE(12))
});
var ImageStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n    flex-shrink: 0;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  "], ["\n    ", "\n    flex-shrink: 0;\n    object-fit: contain;\n    transition: transform 0.3s ease;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  "])), function (_a) {
    var logoSize = _a.logoSize;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", "px;\n      max-width: ", "px;\n    "], ["\n      height: ", "px;\n      max-width: ", "px;\n    "])), logoSize, logoSize);
  })
});
var FauxLogoStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: ", ";\n    text-decoration: none;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    fon-size: 1em;\n    text-transform: capitalize;\n    padding: ", " ", ";\n    font-weight: 600;\n    text-align: center;\n    line-height: 1.1em;\n    height: 82px;\n    min-width: 82px;\n    max-width: 150px;\n    \n  "], ["\n    color: ", ";\n    text-decoration: none;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    fon-size: 1em;\n    text-transform: capitalize;\n    padding: ", " ", ";\n    font-weight: 600;\n    text-align: center;\n    line-height: 1.1em;\n    height: 82px;\n    min-width: 82px;\n    max-width: 150px;\n    \n  "])), theme.COLOR('strong'), theme.UNIT(4), theme.UNIT(5))
});
// -------- Components -------->
var My = {
  Container: styled(animated.div)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: styled(Image)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  FauxLogo: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FauxLogoStyles)
};
export var OrganisationLogoCard = function (props) {
  var className = props.className,
    animate = props.animate,
    index = props.index,
    size = props.size,
    children = props.children;
  var entity = applyOpenGraphThumbnailSize('card')(applyLogoThumbnailSize('card')(props.entity));
  var styles = !animate ? {
    opacity: 1
  } : useSpring({
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    },
    delay: index * 10,
    config: {
      duration: 300
    }
  });
  var url = entity.url;
  var activeThemeMode = useActiveThemeMode();
  var isInverted = activeThemeMode.themeMode === 'dark';
  var image = firstImageProperty(entity, [isInverted ? 'logoInverted' : 'logo', 'openGraph.image.thumbnails.card', 'openGraph.image']);
  var Link = useLink().Link;
  var inner = image ? React.createElement(My.Image, {
    logoSize: size,
    image: image
  }) : React.createElement(My.FauxLogo, null, entity.name);
  return React.createElement(My.Container, {
    logoSize: size,
    title: entity.name,
    style: styles,
    className: cls.name(className)
  }, url ? React.createElement(Link, {
    href: url
  }, inner) : inner);
};
OrganisationLogoCard.defaultProps = OrganisationLogoCardDefaultProps;
OrganisationLogoCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;